/**
 响应拦截器: 响应后的处理
**/

const httpStatusMap = {
  302: '接口重定向了!',
  400: '参数格式错误!',
  404: '请求地址出错!',
  408: '请求超时!',
  500: '服务器内部出错!'
};

/*
 处理http状态异常
*/
export const httpStatusExceptionHandle = err => {
  let msg;
  // 如果是axios判定超时或者请求拦截器触发的非http错误则没有response和message对象
  if (!err.response) {
    const { message } = err;
    if (message.includes('timeout')) {
      msg = '请求超时';
    } else {
      msg = message;
    }
  } else {
    const { response } = err;
    const httpStatus = response.status;
    if (!window.navigator.onLine) {
      msg = '您断网了';
    } else {
      if (httpStatus in httpStatusMap) {
        msg = httpStatusMap[ httpStatus ];
      } else {
        msg = '异常错误，请联系管理员';
      }
    }

    // return Promise.reject(`${ err.response.status }|${ msg }`);
  }
  return Promise.reject(msg);
}

export const responseHandle = resp => {
  // ie9中 response.data为undefined
  if (!resp.data) {
    resp.data = JSON.parse(resp.request.responseText);
  }
  // 如果statusCode < 0，则判定为正常操作报的异常，属于流程错误
  if (resp.data.errCode !== 0 && resp.data.errCode !== 9994) {
    return Promise.reject(resp.data.errMsg);
  }
  return resp.data;
}
